const MAUI_PERSONAL_READ_TOKEN_PATH = '/gateway/api/assist/rovo/v1/maui/media/personal-read-token';

type PersonalReadTokenResponse = {
	token: string;
	collection: string;
};

export type MauiPersonalReadTokenResult = {
	token: string;
	collection: string;
};

export async function fetchMauiPersonalReadToken(
	productHeader: string,
	cloudId?: string,
): Promise<MauiPersonalReadTokenResult> {
	const response = await fetch(MAUI_PERSONAL_READ_TOKEN_PATH, {
		method: 'GET',
		credentials: 'include',
		headers: {
			Accept: 'application/json',
			'X-Product': productHeader,
			// Backend requires the site id; without it the request 400s and no image renders.
			...(cloudId ? { 'X-Cloudid': cloudId } : {}),
		},
	});

	if (!response.ok) {
		throw new Error(
			`Failed to fetch MAUI personal read token: ${response.status} ${response.statusText}`,
		);
	}

	const data: PersonalReadTokenResponse = await response.json();
	return { token: data.token, collection: data.collection };
}
